// pwdResetEndConfirm.js

// Material UI components
import React, { Component } from 'react';
import react, { useState, useEffect, useLayoutEffect } from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import withStyles from '@material-ui/core/styles/withStyles';
import Container from '@material-ui/core/Container';
import CircularProgress from '@material-ui/core/CircularProgress';
import Footer from '../components/footer';
import imageMissing from '../assets/image-missing.jpg';
import withBackground from '../components/withBackground';
import logo from '../assets/app-logo.png';
import backgroundImg from "../assets/house-landscape.jpg";
import { resetVersion } from "../api/service";

import { useNavigate } from "react-router-dom";

import axios from 'axios';

const styles = (theme) => ({
	paper: {
		marginTop: theme.spacing(8),
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center'
	},
	avatar: {
		margin: theme.spacing(1),
		backgroundColor: theme.palette.primary.main
	},
	form: {
		width: '100%',
		marginTop: theme.spacing(3)
	},
	submit: {
		margin: theme.spacing(3, 0, 2)
	},
	customError: {
		color: 'red',
		fontSize: '0.8rem',
		marginTop: 10
	},
	progess: {
		position: 'absolute'
	},
	
});


const PwdResetEndConfirm = ( props) => {
	
	const [state, setState] = useState( {
		//email: '',
		//password: '',
		errors: {},
		loading: false,
		isMDUpper: false,
		width: window.innerWidth,				
	});		
	const [email, setEmail] = useState( '');			
	
	const { classes } = props;
	//const [errors, setErrors] = useState( state.errors);
	//const [loading, setLoading] = useState( state.loading);		
	const navigate = useNavigate();					

	function handleWindowSizeChange() {
		setState({
			...state,
			width: window.innerWidth
		});
	}		
	useEffect( () => {	
	
		resetVersion();	
	
		document.title = process.env.QEE_APP_NAME;    //'Vreed.INSIGHT';
	
		setState( {
			...state,
			isMDUpper: state.width>=900 ? true : false
		});
		console.log( 'state', state);				
		
		window.addEventListener('resize', handleWindowSizeChange);
		return () => {
			window.removeEventListener('resize', handleWindowSizeChange);
		}
												
	}, [state.width]);		
	
	
	return (
		<Grid container direction="row">

		<Grid item style={{width: state.isMDUpper ? '70%' : '0%'}}>
		
			<div style={{
				backgroundColor:'#FBFDFC',				
				backgroundPosition: 'center',
				backgroundSize: 'cover',
				backgroundRepeat: 'no-repeat',
				width: '100%',
				height: '100vh',												
				backgroundImage:`url(${backgroundImg})`
			}} />
		
		</Grid>
		
		<Grid item style={{width: state.isMDUpper ? '30%' : '100%'}}>		
			<Container component="main" maxWidth="xs">
				<CssBaseline />
				<div className={classes.paper}>					
					
					<img src={logo} alt='App Logo' style={{maxHeight:36,marginBottom:8}}/>										
					<Typography component="h3" variant="h3">
						{process.env.QEE_APP_NAME}
					</Typography>										
					<Typography component="h4" variant="h4">
						Passwort zurücksetzen
					</Typography>
					
					<Typography component="h4" variant="h4">
						Passwort geändert
					</Typography>
					<form className={classes.form} noValidate>
						<Typography>
							Dein Passwort wurde erfolgreich geändert! Du kannst es nun für deine Anmeldung einsetzen.
						</Typography>
						<br/><br/>
						<Grid container direction="column" spacing={5}>
							<Grid item>
								<Typography>
								<Link href="login">
									Logge dich hier ein!
								</Link>
								</Typography>
							</Grid>
						</Grid>
					</form>
					<Footer left={state.isMDUpper ? '70%' : '0'} width={state.isMDUpper ? '30%' : '100%'}/>													
				</div>
			</Container>
		</Grid>
		</Grid>
	);
}
export default withStyles(styles)(PwdResetEndConfirm);
